module.exports = __webpack_public_path__ + "img/far-trash.eb67bb70.svg";